const initMobileMenu = () => {
    const header = document.querySelector(".header");
    const hamburgerIcon = document.querySelector(".hamburger-icon");
    const closeIcon = document.querySelector(".close-icon");
    const body = document.querySelector("body");
    if (header && hamburgerIcon && closeIcon) {
        hamburgerIcon.addEventListener("click", () => {
            closeIcon.classList.add("active");
            hamburgerIcon.classList.remove("active");
            header.classList.add("active");
        });
        closeIcon.addEventListener("click", () => {
            closeIcon.classList.remove("active");
            hamburgerIcon.classList.add("active");
            header.classList.remove("active");
        });
    }
    initAccordionForMobileMenu();
};
const initAccordionForMobileMenu = () => {
    const accordionTogglerArray = document.querySelectorAll(".accordion-toggler-mobile");
    if (accordionTogglerArray && accordionTogglerArray.length > 0) {
        accordionTogglerArray.forEach((accordionToggler) => {
            accordionToggler.addEventListener("click", () => {
                accordionToggler.classList.toggle("active");
                for (const sibling of accordionToggler.parentNode.children) {
                    if (sibling.classList.contains("accordion-child-mobile")) {
                        sibling.classList.toggle('active');
                    }
                }
            });
        });
    }
};
